import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {FlowBasicState} from '@gongxigames/framework/slot/modules/flow/states/FlowBasicState';
import {GenericPopupEvents} from '@gongxigames/framework/slot/modules/genericPopup';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import {PickBonusView} from '@gongxigames/framework/slot/modules/pick';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad';
import {BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';
import {FlowModule} from '@gongxigames/framework/slot/modules/flow/FlowModule';

export class FlowPickState extends FlowBasicState {
    protected setupEvents(): void {
        this.setEventHandler(LogicEvents.PICK_RESPONSE, this.onPickResponse.bind(this));
        this.setEventHandler(GenericPopupEvents.FADE_OUT_STARTED, this.onPopupFadeOut.bind(this));
        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
        this.setEventHandler(FlowModuleEvents.CAN_SPIN, this.onDecideNextState.bind(this));
    }

    protected onPickResponse(): void {
        this.clearEventsQueue();

        switch (this.module.logic.nextAction) {
            case Action.SELECT: {
                this.setupAfterPickSelectBonusSequence();
                break;
            }
            case Action.RESPIN: {
                this.setupAfterPickRespinBonusSequence();
                break;
            }
            default:
                break;
        }

    }

    protected setupAfterPickSelectBonusSequence(): void {
        this.addEventToWaitingList(GenericPopupEvents.POPUP_CLOSED, FlowModuleEvents.SELECT_BONUS_START);
    }

    protected setupAfterPickRespinBonusSequence(): void {
        this.addEventToWaitingList(GenericPopupEvents.POPUP_CLOSED, FlowModuleEvents.RESPIN_WIN);
    }

    protected onPopupFadeOut(type: symbol): void {
        if (type === PickBonusView.NAME) {
            this.checkRestore();
        }
    }

    protected onPopupClosed(type: symbol): void {
        if (type === PickBonusView.NAME) {
            this.completePickBonus();
        }
    }

    protected checkRestore(): void {
        if (this.module.isRestore) {
            this.emit(FlowModuleEvents.PICK_GAME_RESTORED);
        }
    }

    protected completePickBonus(): void {
        this.emit('General.UI.ENABLE', UIDisableReason.TRIGGERING_FEATURE);

        if (this.isNextBonus()) {
            this.emit(FlowModuleEvents.SKIP_PICK_BONUS_AWARD);
            this.onDecideNextState();

            return;
        }

        this.emit(FlowModuleEvents.START_PICK_BONUS_AWARD);

        if (this.isBigWinInCurrentRound()) {
            this.emit(FlowModuleEvents.BIG_WIN_AFTER_BONUS_GAME_STARTED);
            this.addCallbackToWaitingLIst(BigWinEvents.FINISHED, this.onDecideNextState.bind(this));
        } else {
            this.onDecideNextState();
        }
    }

    protected isNextBonus(): boolean {
        const {nextAction} = this.module.logic;

        return nextAction === Action.RESPIN || nextAction === Action.SELECT ||
            // @ts-ignore TODO: refactoring required
            nextAction === Action.MINISPIN;
    }

    protected isBigWinInCurrentRound(): boolean {
        return this.getFeatureWin() + this.module.logic.getBaseWinFromTriggeringRound(this.convertPreviousActionToBonusID()) >=
            this.module.logic.getBigWinLimit();
    }

    protected convertPreviousActionToBonusID(): number {
        return this.module.logic.previousAction - 1;
    }

    protected getFeatureWin(): number {
        return this.module.logic.getTotalWin() - this.module.logic.previousSpinRoundWin;
    }

    protected onDecideNextState(): void {
        if (this.module.logic.nextAction === Action.RESPIN) {
            this.emit(FlowModuleEvents.HAS_RESPIN_ON_NEXT_SPIN);
            this.module.gotoState(FlowModule.RESPIN_BASIC_STATE);
        } else if (this.module.logic.nextAction === Action.FREESPIN) {
            this.module.gotoState(FlowModule.FREE_SPINS_STATE);
        } else {
            this.module.gotoState(FlowModule.BASIC_STATE);
        }
    }
}
